module.exports = __webpack_public_path__ + "media/img/home/clients-map/map3-1978076b927ada56ec20c85f95c8b8db.png";